class User {
  constructor({
    id,
    lastLogin,
    isAdmin,
    isStaff,
    isMember,
    isServiceUser,
    email,
    firstName,
    lastName,
    group,
    fullName,
    isActive,
    requireTfa,
    userLevel,
    createdAt,
    organisation,
    oid,
    membershipCount = 0,
  }) {
    this.id = id;
    this.lastLogin = lastLogin;
    this.isAdmin = isAdmin;
    this.isStaff = isStaff;
    this.isMember = isMember;
    this.isServiceUser = isServiceUser;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.group = group;
    this.fullName = fullName;
    this.isActive = isActive;
    this.requireTfa = requireTfa;
    this.userLevel = userLevel;
    this.createdAt = createdAt;
    this.organisationId = organisation;
    this.oid = oid ?? null;
    // Number of org memberships (UserOrganisations rows). Drives whether the
    // "Working in" switcher is shown for non-staff users - it's only useful
    // when there's more than one org to switch between. Staff are exempt: the
    // isStaff flag lets them act as a member of any org without memberships.
    this.membershipCount = membershipCount ?? 0;
  }

  isStaff() {
    return this.isStaff;
  }

  isStandardUser() {
    return this.userLevel === "standard";
  }

  isUploadOnlyUser() {
    return this.userLevel === "upload only";
  }

  toServerModel() {
    return {
      id: this.id,
      lastLogin: this.lastLogin,
      isAdmin: this.isAdmin,
      isStaff: this.isStaff,
      isMember: this.isMember,
      isServiceUser: this.isServiceUser,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      group: this.group,
      fullName: this.fullName,
      isActive: this.isActive,
      requireTfa: this.requireTfa,
      userLevel: this.userLevel,
      createdAt: this.createdAt,
      organisation: this.organisationId,
      oid: this.oid,
    };
  }
}

export default User;
